import React from 'react'
import './WelcomePortfolioCard.scss'
import {Fade, Zoom} from "react-reveal";
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const arrow = assetUrl+"images/arrow-purple-large.png";
const card_man = assetUrl+"images/welcome_landing-portfolioCard_man1.png";
const card_bg = assetUrl+"images/animation_welcome_card_bg.svg";

const WelcomePortfolioCard = (props) => {
	const stylePrefix = "onboard-"
	const styleLanding = "landing-"

	return (
    <div>
	    <div
		    className={" mb-4 px-3 py-1 " + stylePrefix + 'welcome-cardWrap '}
		    style={{position: 'relative'}}>
		    <div className={'d-flex justify-content-between'}>
			    <div className={"d-flex flex-column justify-content-center"}>
				    <p className={styleLanding + "portfolio-card-text mb-0"}>
					    Let's start building
				    </p>
				    <div className={'d-flex align-items-center '}><p
					    className={styleLanding + "portfolio-card-value mb-0 "}>your Portfolio!</p>
					    {/*<img src={ greenUpArrow }*/}
					    {/*     alt={'alt'} className={styleLanding + "arrow-icon my-auto mr-2"}/>*/}
				    </div>
				    <div className={'d-flex align-items-center mt-3'} onClick={()=>props.history.push("/portfolio")}><p
					    className={styleLanding + "portfolio-card-portfolio mb-0 mr-1"}>Start Now</p>
					    <img src={arrow} alt={'alt'} className={styleLanding + "arrow-icon mr-2"}/>
				    </div>
			    </div>
			    <div className={stylePrefix + "portfolio-card-imageWrapper"}>
				    <Fade distance={"50px"} bottom><img src={card_man} alt={"alt"}
				                                        className={"img-card-man"}/></Fade>
				    {/*<div className={"img-card-bg"}><Zoom delay={300}><img src={card_bg}*/}
				    {/*                                                      alt={"alt"}/></Zoom></div>*/}
			    </div>
		    </div>

	    </div>
    </div>
  )
}

export default withRouter(WelcomePortfolioCard)
